import { isValidCPF, isValidCNPJ } from "@brazilian-utils/brazilian-utils";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import Swal from "sweetalert2";
import { AtendimentoForms } from "../../components/Atendimento/atendimento-forms";
// import { Chat } from "../../components/Atendimento/chat";
// import { ChatButton } from "../../components/Atendimento/chat-button";
import FilaCobranca from "../../components/FilaCobranca/FilaConbracaSemWhats";
import { useAuth } from "../../context/AuthContext";
import { useDividas } from "../../context/DividasContext";
import { useOperador } from "../../context/OperadorContext";
import { Spinner } from "../../components/Spinner";
// import ReactInputMask from "react-input-mask";
import { ResponsiveModal } from "../../components/ResponsiveModal";
// import { Checkbox, Label, Radio, ToggleSwitch } from "flowbite-react";
// import { OptionBtn } from "./option-btn";
import { ConsultaDebitoResponse } from "../../types/divida-interface";


export function Operador() {
  const [isCpfSearch, setIsCpfSearch] = useState(true);
  const { tab, setTab } = useOperador();
  const { setDevedor, devedor } = useDividas();
  // const [isChatOpen, setIsChatOpen] = useState(false);
  const { validToken, cookies, decodedToken } = useAuth();
  const [, setCookies] = useCookies(["token", "user"]);
  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setCpfValue("");
    setIsCpfInvalid(false)
  };
  const { getDividasGazin } = useDividas();
  const [isCpfInvalid, setIsCpfInvalid] = useState<null | boolean>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [cpfValue, setCpfValue] = useState("");
  // const { setModal, onClose } = useModal()

  const findByCpf: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    // const values = cpfValue as typeof cpfValue & {
    //   cpf: { value: string };
    // };
    // const { cpf } = values;
    // console.log(cpfValue)
    const numbers = cpfValue.replace(/\D/g, "");
    // console.log(numbers)
    if (numbers.length === 11) {
      if (!isValidCPF(numbers)) {
        setIsCpfInvalid(true);
        setIsLoading(false);
        return;
      }
    } else {
      if (!isValidCNPJ(numbers)) {
        setIsCpfInvalid(true);
        setIsLoading(false);
        return;
      }
    }
    // <IoIosWarning className="fill-amber-500 m-4" size={70} />

    setCpfValue('')
    try {
      await getDividasGazin({ cpf_cnpj: numbers, id: Number(numbers) });
      handleOpenTab("atendimento");
    } catch (err) {
      Swal.fire({
        title: "Ops!",
        text: "Contrato não localizado!",
        confirmButtonColor: "#103680",
      });
      // setModal("Ops! Contrato não localizado!", "Aviso", false, true);
    } finally {
      setIsLoading(false);
      closeModal();
      setCpfValue("");
      //@ts-ignore
    }
  };

  function handleOpenTab(tab: string) {
    setTab(tab);
  }

  useEffect(() => {
    validToken(cookies?.token);
    if (!cookies?.user) {
      const decoded = decodedToken();
      setCookies("user", {
        id_operador: decoded.id_usuario,
        nome: decoded.nome,
      });
    }
    setDevedor({} as ConsultaDebitoResponse);
  }, []);

  function maskCPFCNPJ(value: string) {
    const val = value.trim()
    if (val.length >= 15) {
      return val
        .replace(/\D/g, '')
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    } else {
      return val
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    }
  }
  return (
    <>
      <section>
        <div
          className={`m-4 mt-10 flex max-h-max  flex-grow flex-col overflow-y-auto
            ${tab === "fila-cobranca" ? "w-[121%]" : ""}`}
        >
          <div>
            <button
              className={`aba-operador mr-3 ${tab === "fila-cobranca" ? " bg-slate-300" : " bg-slate-200"
                }
              `}
              onClick={() => handleOpenTab("fila-cobranca")}
            >
              Fila de cobrança
            </button>
            <button
              className={`aba-operador mr-3 ${tab === "atendimento" ? " bg-slate-300" : " bg-slate-200"
                } ${!devedor.name && "cursor-not-allowed"}
              `}
              disabled={!devedor.name ? true : false}
              onClick={() => handleOpenTab("atendimento")}
            >
              Atendimento
            </button>
            <button
              disabled
              className={`aba-operador mr-3 cursor-not-allowed ${tab === "dados-credito" ? " bg-slate-300" : " bg-slate-100"
                }
              `}
              onClick={() => handleOpenTab("dados-credito")}
            >
              Dados crédito
            </button>
            <button
              className={`aba-operador mr-3 cursor-pointer${tab === "dados-credito" ? " bg-slate-300" : " bg-slate-100"
                }
              `}
              onClick={openModal}
            >
              Consulta por CPF
            </button>
          </div>
          <div
            className={
              "mb-2 flex h-[85vh] w-[81%] items-center justify-center gap-2 rounded-lg border-2 bg-slate-300 px-2 py-2"
            }
          >
            {tab === "fila-cobranca" && (
              <FilaCobranca handleOpenTab={handleOpenTab} />
            )}
            {tab === "atendimento" && (
              <>
                <AtendimentoForms />
                {/* {!isChatOpen && <ChatButton onClick={() => setIsChatOpen(true)} />}
                <div className="relative">
                  <Chat isOpen={isChatOpen} closeSidebar={setIsChatOpen} operadora={''} />
                </div> */}
              </>
            )}
            {tab === "dados-credito" && (
              <FilaCobranca handleOpenTab={handleOpenTab} />
            )}
          </div>
        </div>

        {/* <ModalAviso message="Contrato com acordo vigente. Emita a segunda via." /> */}
      </section>
      <>
        <ResponsiveModal
          rounded
          open={showModal}
          onClose={closeModal}
          center
          closeIcon
          closeOnOverlayClick
          closeOnEsc
        >
          <div className="h-full p-4 text-center">
            <h1 className="text-2xl font-medium text-primary">
              Consulta CPF/CNPJ
              {/* {isCpfSearch ? "CPF" : "CNPJ"} */}
            </h1>
            <form
              onSubmit={findByCpf}
              className="flex flex-col items-center p-4"
            >
              {/* <div className="flex items-center gap-2 h-5 mt-2 mb-4">
                <OptionBtn
                  label="CPF"
                  onClick={() => {
                    setIsCpfSearch(true);
                    setCpfValue("");
                  }}
                  isActive={isCpfSearch}
                />
                <OptionBtn
                  label="CNPJ"
                  onClick={() => {
                    setIsCpfSearch(false);
                    setCpfValue("");
                  }}
                  isActive={!isCpfSearch}
                />
              </div> */}
              <div className="">
                {/* <ReactInputMask
                  mask={isCpfSearch ? "999.999.999-99" : "99.999.999/9999-99"}
                  autoComplete={"off"}
                  placeholder={
                    isCpfSearch ? "000.000.000-00" : "00.000.000/0000-00"
                  }
                  className={`h-12 w-full rounded-md border text-center text-2xl text-gray-800 outline-none focus:border-2 focus:border-primary ${isCpfInvalid
                    ? "border-red-600 focus:border-red-600"
                    : "focus:border-primary"
                    }`}
                  name="cpf"
                  id="cpf"
                  onChange={(e) => {
                    // IsCPFCNPJ(e.target.value)
                    setCpfValue(e.target.value);
                    setIsCpfInvalid(false);
                  }}
                  value={cpfValue}
                /> */}
                <input type={'text'} maxLength={18} value={maskCPFCNPJ(cpfValue)} className={`h-12 w-full rounded-md border text-center text-xl text-gray-800 outline-none focus:border-2 focus:border-primary ${isCpfInvalid
                  ? "border-red-600 focus:border-red-600"
                  : "focus:border-primary"
                  }`}
                  onChange={(e) => setCpfValue(e.target.value)}
                  placeholder={
                    "000.000.000-00"
                  }
                />
                {isCpfInvalid && (
                  <p className="mb-2 text-right text-red-600">
                    CPF/CNPJ Inválido
                  </p>
                )}
              </div>

              <div className="mt-5 flex w-full gap-2">
                {isLoading ? (
                  <div className="flex w-full justify-center">
                    <Spinner size="sm" />
                  </div>
                ) : (
                  <>
                    <button
                      type="submit"
                      className="w-full rounded-md bg-primary p-2 text-base font-semibold text-white"
                    >
                      OK
                    </button>
                    <button
                      onClick={closeModal}
                      type="button"
                      className="w-full rounded-md bg-slate-400 p-2 text-base font-semibold text-white"
                    >
                      Cancelar
                    </button>
                  </>
                )}
              </div>
            </form>
          </div>
        </ResponsiveModal>
      </>
    </>
  );
}
